export default __webpack_public_path__ + "static/media/OPD_CARD_BLANK_1.4f08b862.png";